import { IonBackButton, IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import { useLocation } from "react-router-dom";
import CreateInventoryLocation from "../components/CreateInventoryLocation";
import { InventoryLocationPartnerType } from "../services/inventoryLocation.service";

// Backs both the "Add Distributor" and "Add Retailer" Home quick links --
// partnerType comes from route state (set by Home.tsx's navigateTo call),
// CreateInventoryLocation reads the same state to drive the form itself.
const AddChannelPartner: React.FC = () => {
  const location = useLocation();
  const partnerType: InventoryLocationPartnerType =
    (location.state as any)?.partnerType ?? InventoryLocationPartnerType.RETAILER;
  const title = partnerType === InventoryLocationPartnerType.DISTRIBUTOR ? "Add Distributor" : "Add Retailer";

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton />
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{title}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <CreateInventoryLocation />
      </IonContent>
    </IonPage>
  );
};

export default AddChannelPartner;
